export const CHUNK_SIZE: number = 16;

